import React from "react";

const NoNotes = ({ fill }) => (
  <svg
    width="380"
    height="220"
    viewBox="0 0 380 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M175.225 0H0V121.319H175.225V0Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <path d="M173.865 1.8103H1.81104V119.959H173.865V1.8103Z" fill="#F7F7F7" />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M29.7702 45.0438C31.5215 45.0438 32.9412 43.6244 32.9412 41.8735C32.9412 40.1225 31.5215 38.7031 29.7702 38.7031C28.0188 38.7031 26.5991 40.1225 26.5991 41.8735C26.5991 43.6244 28.0188 45.0438 29.7702 45.0438Z"
        fill={fill}
      />
      <path
        opacity="0.5"
        d="M29.7702 64.0575C31.5215 64.0575 32.9412 62.6381 32.9412 60.8871C32.9412 59.1362 31.5215 57.7168 29.7702 57.7168C28.0188 57.7168 26.5991 59.1362 26.5991 60.8871C26.5991 62.6381 28.0188 64.0575 29.7702 64.0575Z"
        fill={fill}
      />
      <path
        opacity="0.5"
        d="M29.7702 83.067C31.5215 83.067 32.9412 81.6476 32.9412 79.8966C32.9412 78.1457 31.5215 76.7263 29.7702 76.7263C28.0188 76.7263 26.5991 78.1457 26.5991 79.8966C26.5991 81.6476 28.0188 83.067 29.7702 83.067Z"
        fill={fill}
      />
    </g>
    <path d="M149.081 40.063H53.0898V43.6838H149.081V40.063Z" fill="#E0E0E0" />
    <path
      d="M149.081 59.0723H53.0898V62.6931H149.081V59.0723Z"
      fill="#E0E0E0"
    />
    <path
      d="M149.081 78.0859H53.0898V81.7068H149.081V78.0859Z"
      fill="#E0E0E0"
    />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M236.351 49.3403H61.126V170.66H236.351V49.3403Z"
        fill="url(#paint1_linear)"
      />
    </g>
    <path d="M234.991 51.1506H62.937V169.3H234.991V51.1506Z" fill="#F7F7F7" />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M90.8966 94.3839C92.648 94.3839 94.0677 92.9645 94.0677 91.2135C94.0677 89.4626 92.648 88.0432 90.8966 88.0432C89.1453 88.0432 87.7256 89.4626 87.7256 91.2135C87.7256 92.9645 89.1453 94.3839 90.8966 94.3839Z"
        fill={fill}
      />
      <path
        opacity="0.5"
        d="M90.8966 113.398C92.648 113.398 94.0677 111.978 94.0677 110.227C94.0677 108.476 92.648 107.057 90.8966 107.057C89.1453 107.057 87.7256 108.476 87.7256 110.227C87.7256 111.978 89.1453 113.398 90.8966 113.398Z"
        fill={fill}
      />
      <path
        opacity="0.5"
        d="M90.8966 132.411C92.648 132.411 94.0677 130.992 94.0677 129.241C94.0677 127.49 92.648 126.071 90.8966 126.071C89.1453 126.071 87.7256 127.49 87.7256 129.241C87.7256 130.992 89.1453 132.411 90.8966 132.411Z"
        fill={fill}
      />
    </g>
    <path
      d="M210.203 89.4033H114.212V93.0241H210.203V89.4033Z"
      fill="#E0E0E0"
    />
    <path
      d="M210.203 108.417H114.212V112.038H210.203V108.417Z"
      fill="#E0E0E0"
    />
    <path
      d="M210.203 127.427H114.212V131.047H210.203V127.427Z"
      fill="#E0E0E0"
    />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M297.478 98.6848H122.252V220.004H297.478V98.6848Z"
        fill="url(#paint2_linear)"
      />
    </g>
    <path
      d="M296.117 100.495H124.063V218.644H296.117V100.495Z"
      fill="#EEEEEE"
    />
    <path
      d="M152.023 143.724C153.774 143.724 155.194 142.305 155.194 140.554C155.194 138.803 153.774 137.384 152.023 137.384C150.271 137.384 148.852 138.803 148.852 140.554C148.852 142.305 150.271 143.724 152.023 143.724Z"
      fill={fill}
    />
    <path
      d="M152.023 162.738C153.774 162.738 155.194 161.319 155.194 159.568C155.194 157.817 153.774 156.397 152.023 156.397C150.271 156.397 148.852 157.817 148.852 159.568C148.852 161.319 150.271 162.738 152.023 162.738Z"
      fill={fill}
    />
    <path
      d="M152.023 181.752C153.774 181.752 155.194 180.332 155.194 178.581C155.194 176.831 153.774 175.411 152.023 175.411C150.271 175.411 148.852 176.831 148.852 178.581C148.852 180.332 150.271 181.752 152.023 181.752Z"
      fill={fill}
    />
    <path
      d="M271.329 138.744H175.338V142.364H271.329V138.744Z"
      fill="#DFDFDF"
    />
    <path
      d="M271.329 157.757H175.338V161.378H271.329V157.757Z"
      fill="#DFDFDF"
    />
    <path
      d="M271.329 176.771H175.338V180.392H271.329V176.771Z"
      fill="#DFDFDF"
    />
    <g opacity="0.5">
      <path
        opacity="0.5"
        d="M376.399 97.0704C375.147 96.9911 373.858 96.1277 373.733 94.8846C373.583 93.3995 374.985 92.3107 375.873 91.0968C377.426 88.936 377.238 85.8282 375.836 83.5882C374.434 81.3481 372.006 79.8338 369.456 79.083C367.341 78.4531 364.867 78.1027 363.615 76.2589C361.637 73.2637 364.695 69.5052 364.958 65.9261C365.209 62.518 362.388 59.1766 358.983 58.8346C357.014 58.6469 354.703 59.2517 353.276 57.8751C352.884 57.4716 352.585 56.9876 352.399 56.4568C351.481 54.0749 351.911 51.4218 352.028 48.8731C352.145 46.3243 351.794 43.4501 349.829 41.8274C348.694 40.8805 347.192 40.5092 345.736 40.2715C341.317 39.5498 336.79 39.7959 332.359 40.4467C326.188 41.3519 319.754 43.2708 315.669 47.9804C311.585 52.69 311.051 60.8661 315.982 64.6663C315.565 64.3326 315.749 63.5942 316.345 62.7099C316.345 62.7933 316.345 62.8726 316.345 62.956C316.343 65.5224 317.13 68.0275 318.6 70.1317C320.069 72.236 322.15 73.8376 324.561 74.7196V75.5998C323.663 75.8183 322.806 76.1804 322.024 76.6718C313.621 78.7451 296.814 89.0987 296.814 89.0987L272.134 93.2702C272.134 93.2702 260.034 95.1307 260.493 96.9953C260.952 98.86 272.134 97.4625 272.134 97.4625H297.09C299.354 97.4598 301.581 96.8859 303.565 95.7939L317.209 88.2853C317.142 89.3698 317.109 90.4878 317.101 91.6224C314.943 93.1659 312.832 96.5364 317.267 103.478L317.301 103.286C317.301 103.348 317.301 103.415 317.301 103.478L312.34 126.346C310.829 127.464 309.795 128.494 310.153 129.045C310.362 129.362 310.921 129.42 311.685 129.316L304.817 161.019L324.06 184.254L327.273 202.651L324.248 205.55L313.024 207.636C312.774 207.681 312.55 207.819 312.396 208.022C312.243 208.225 312.17 208.478 312.194 208.731C312.217 208.984 312.335 209.22 312.523 209.391C312.712 209.561 312.957 209.656 313.212 209.655H337.804V205.02H338.029L337.612 199.455L345.385 194.374L342.836 190.478L342.473 190.716L336.265 182.044L335.201 168.378L346.55 127.272V127.226L343.762 115.759L348.648 113.281C350.187 112.499 351.392 111.189 352.041 109.59C352.69 107.991 352.74 106.212 352.182 104.579C351.436 102.414 350.513 99.8611 349.437 97.2665C351.05 98.8761 352.916 100.211 354.961 101.217C363.047 105.017 372.744 101.396 379.996 96.1819C378.848 96.6533 377.647 97.1538 376.399 97.0704ZM341.568 106.719L339.836 99.6025L342.189 105.618C341.876 106.164 341.643 106.573 341.564 106.723L341.568 106.719ZM331.904 75.6665V75.1326C333.513 74.74 335.028 74.0309 336.361 73.0468C336.245 74.9213 336.427 76.8021 336.899 78.6199C335.801 77.1974 334.216 76.213 331.9 75.6749L331.904 75.6665ZM318.836 157.67L328.783 128.916L322.683 163.051L318.836 157.67Z"
        fill="url(#paint3_linear)"
      />
    </g>
    <path
      d="M342.202 188.664L333.486 194.362L323.439 203.994C323.273 204.154 323.168 204.366 323.143 204.594C323.117 204.823 323.171 205.053 323.297 205.245C323.368 205.354 323.459 205.448 323.567 205.521C323.674 205.595 323.794 205.646 323.921 205.673C324.048 205.7 324.18 205.701 324.307 205.677C324.435 205.653 324.557 205.604 324.665 205.533L344.693 192.452L342.202 188.664Z"
      fill="#333333"
    />
    <path
      d="M324.19 85.5571L304.041 96.6157C302.112 97.6747 299.946 98.2299 297.745 98.23H273.478V94.1503L297.474 90.0748C297.474 90.0748 324.645 73.3346 326.439 78.7659C328.233 84.1972 324.19 85.5571 324.19 85.5571Z"
      fill={fill}
    />
    <path
      d="M345.832 127.205H312.39L317.397 104.12C317.397 91.5559 314.893 76.6345 327.465 76.6345C340.032 76.6345 338.676 85.2194 338.676 97.7798L345.832 127.205Z"
      fill={fill}
    />
    <path
      d="M324.453 67.8618H331.579V77.7357C331.579 78.6064 331.233 79.4415 330.617 80.0571C330.002 80.6728 329.166 81.0187 328.295 81.0187H327.736C326.865 81.0187 326.03 80.6728 325.414 80.0571C324.799 79.4415 324.453 78.6064 324.453 77.7357V67.8618Z"
      fill="#FDA57D"
    />
    <path
      d="M312.39 127.155L305.263 160.043L334.32 195.125L341.993 189.098L318.874 156.756L329.113 127.155H312.39Z"
      fill="#E0E0E0"
    />
    <path
      opacity="0.04"
      d="M312.39 127.155L305.263 160.043L334.32 195.125L341.993 189.098L318.874 156.756L329.113 127.155H312.39Z"
      fill="black"
    />
    <path
      d="M328.838 127.155L321.474 168.395L327.478 202.797H337.537L334.796 167.172L345.832 127.155H328.838Z"
      fill="#E0E0E0"
    />
    <path
      opacity="0.05"
      d="M340.942 107.286L318.757 123.138L320.568 126.308L346.504 113.156C348.004 112.396 349.179 111.119 349.811 109.561C350.443 108.003 350.489 106.269 349.942 104.679C346.85 95.7105 340.942 107.286 340.942 107.286Z"
      fill="black"
    />
    <path
      opacity="0.05"
      d="M334.975 89.028L342.294 107.737L319.663 120.848L321.928 126.734L347.864 113.581C349.364 112.822 350.539 111.545 351.171 109.987C351.803 108.429 351.849 106.695 351.302 105.105C348.21 96.1488 341.822 80.3221 336.402 84.0431C335.637 84.5912 335.079 85.382 334.82 86.287C334.561 87.192 334.616 88.158 334.975 89.028Z"
      fill="black"
    />
    <path
      d="M334.525 88.1226L341.847 106.836L319.663 121.774L321.014 125.854L347.401 112.701C348.901 111.941 350.076 110.665 350.708 109.106C351.34 107.548 351.386 105.814 350.839 104.225C347.747 95.2684 341.359 79.4418 335.939 83.1627C335.181 83.7112 334.63 84.4984 334.373 85.3979C334.117 86.2975 334.17 87.257 334.525 88.1226Z"
      fill={fill}
    />
    <path
      d="M337.32 202.801H326.889L313.208 205.366C312.981 205.409 312.777 205.53 312.63 205.707C312.483 205.884 312.402 206.108 312.402 206.338C312.402 206.6 312.507 206.852 312.692 207.037C312.877 207.223 313.129 207.327 313.391 207.327H337.303L337.32 202.801Z"
      fill="#333333"
    />
    <path
      opacity="0.05"
      d="M335.509 89.178C335.509 89.178 340.933 96.4197 340.036 101.851L335.509 89.178Z"
      fill="black"
    />
    <path
      opacity="0.05"
      d="M324.453 77.0472C326.737 77.8812 329.218 78.0148 331.579 77.431V68.7668H324.453V77.0472Z"
      fill="black"
    />
    <path
      d="M328.646 76.8722C335.375 76.8722 340.829 71.4187 340.829 64.6915C340.829 57.9642 335.375 52.5107 328.646 52.5107C321.917 52.5107 316.462 57.9642 316.462 64.6915C316.462 71.4187 321.917 76.8722 328.646 76.8722Z"
      fill="#FDA57D"
    />
    <path
      d="M273.478 94.1504C273.478 94.1504 261.707 95.9608 262.158 97.7712C262.609 99.5817 273.478 98.2259 273.478 98.2259V94.1504Z"
      fill="#FDA57D"
    />
    <path
      d="M319.963 121.857C319.963 121.857 309.427 127.414 310.45 128.978C311.472 130.542 321.298 125.708 321.298 125.708L319.963 121.857Z"
      fill="#FDA57D"
    />
    <path
      d="M319.663 91.4431C319.663 91.4431 310.537 93.4371 317.363 104.116L319.663 91.4431Z"
      fill={fill}
    />
    <path
      opacity="0.05"
      d="M330.528 92.3484C330.528 92.3484 321.403 94.3424 328.229 105.021L330.528 92.3484Z"
      fill="black"
    />
    <path
      d="M330.983 92.3484C330.983 92.3484 321.858 94.3424 328.684 105.021L330.983 92.3484Z"
      fill={fill}
    />
    <path
      d="M337.704 68.6C335.297 72.5003 335.443 77.5645 337.037 81.8611C338.63 86.1577 341.514 89.837 344.434 93.3702C347.171 96.6824 350.105 100.024 353.993 101.851C361.858 105.547 371.284 102.026 378.34 96.9577C377.221 97.4333 376.049 97.9213 374.839 97.8421C373.629 97.7628 372.369 96.9244 372.244 95.7188C372.098 94.2755 373.495 93.2159 374.33 92.0354C375.84 89.9496 375.657 86.9128 374.296 84.7144C372.936 82.516 370.575 81.0769 368.092 80.3343C366.035 79.7211 363.615 79.3791 362.43 77.5895C360.511 74.6695 363.482 71.0236 363.736 67.5446C363.982 64.2324 361.233 60.9828 357.928 60.6658C356.013 60.4823 353.756 61.0829 352.379 59.7314C352.004 59.337 351.719 58.8659 351.544 58.3506C350.651 56.0354 351.069 53.4533 351.181 50.9754C351.294 48.4976 350.952 45.711 349.045 44.1259C347.939 43.2081 346.483 42.8452 345.064 42.6158C340.767 41.915 336.365 42.1527 332.059 42.7868C326.055 43.667 319.804 45.5316 315.828 50.1119C311.852 54.6922 311.334 62.6264 316.133 66.3557C314.435 65.0417 322.713 57.3036 326.601 59.6813C331.028 62.3678 331.12 68.8586 337.704 68.6Z"
      fill="#333333"
    />

    <defs>
      <linearGradient
        id="paint0_linear"
        x1="87.6127"
        y1="121.319"
        x2="87.6127"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="62525.5"
        y1="49682.3"
        x2="62525.5"
        y2="14399"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="88257.1"
        y1="64081.3"
        x2="88257.1"
        y2="28799.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="109278"
        y1="117037"
        x2="109278"
        y2="47895.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#808080" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="#808080" stop-opacity="0.12" />
        <stop offset="1" stop-color="#808080" stop-opacity="0.1" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="380" height="220" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NoNotes;
